export default __webpack_public_path__ + "static/media/sampleposition.21ae93a6.png";